import { createChallengeService } from '@radevents/shared';
import api from './api';

export const challengeService = createChallengeService(api);
export default challengeService;
